import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Hero from '../layout/Hero';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import CookieConsent from '../common/CookieConsent';
import WhyChooseVirginVoyages from '../layout/WhyVirginVoyages';
import WhyRevolutionTravel from '../layout/WhyRevolutionTravel';
import BookNow from '../layout/BookNow';
import ContactUs from '../layout/ContactUs';
import ReactGA from 'react-ga4';

const LandingPage = () => {
  const { hasConsent, hasAnalyticsConsent } = useCookieConsent();

  useEffect(() => {
    // Only initialize analytics if user has given consent
    if (hasAnalyticsConsent) {
      // ReactGA.initialize('G-YCRF742TW0');
      // ReactGA.send({ hitType: "pageview", page: "/landing-page" });
    }
  }, [hasAnalyticsConsent]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const token = await window.grecaptcha.enterprise.execute(
        process.env.REACT_APP_VV_CONTEST_RECAPTCHA_SITE_KEY, 
        { action: 'submit' }
      );
      
      // Send token with your API request
      const response = await fetch('/api/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          // ... other form data ...
          recaptchaToken: token
        })
      });
      
      // Handle response
    } catch (error) {
      console.error('reCAPTCHA error:', error);
    }
  };

  return (
    <div className="relative min-h-screen">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header />
      </div>
      <div className="pt-16"> {/* Add padding to account for fixed header */}
        <Hero />
        <WhyChooseVirginVoyages />
        <WhyRevolutionTravel />
        <BookNow />
        <ContactUs />
      <div className="h-24"></div>
      </div>
      {!hasConsent && <CookieConsent />}
    </div>
  );
};

export default LandingPage;